import React from 'react'

import ReactModal from '../ReactModal'
import RepeatOptionsView from '../RepeatOptionsView'

import { MODAL_DELETE } from '../../helpers/constants'
import { IMG } from '../../themes'

import {
  StyleDeleteRepeatModalHeader,
  StyleDeleteRepeatModalContent,
  StyleDeleteRepeatModalFooter,
} from './styles'

const DeleteRepeatModal = (props) => {
  const {
    isVisible,
    selectedKey,
    language,
    onClose,
    onSubmit,
    onSelected,
    colorTheme,
  } = props

  return (
    <ReactModal isVisible={isVisible} width={420}>
      <StyleDeleteRepeatModalHeader>
        <label className='repeat-header-modal'>{MODAL_DELETE.REPEAT_BOOKING_HEADER[language]}</label>
        <img
          className='pointer'
          src={IMG['close.svg']}
          onClick={onClose}
          alt='close'
        />
      </StyleDeleteRepeatModalHeader>

      <StyleDeleteRepeatModalContent>
        <RepeatOptionsView
          selectedKey={selectedKey}
          language={language}
          onSelected={onSelected}
          colorTheme={colorTheme}
        />
      </StyleDeleteRepeatModalContent>

      <StyleDeleteRepeatModalFooter>
        <button
          className='submit-button'
          onClick={onSubmit}
        >
          {MODAL_DELETE.DELETE[language]}
        </button>
      </StyleDeleteRepeatModalFooter>
    </ReactModal>
  )
}

export default DeleteRepeatModal
